module.exports = __webpack_public_path__ + "static/media/IC-beneficios-act.c5ebce26.svg";